import { ColDef } from 'ag-grid-community';
import { ExhibitHistory } from 'api/endpoints/exhibits';
import {
  ExhibitHistoryGrid,
  HistoryGridRow,
} from 'components/ExhibitsExport/ExhibitHistoryGrid';
import { useExhibitExporterContext } from 'pages/ExhibitExporterPage/providers';
import { useMemo } from 'react';
import { formatDate, READABLE_DATETIME_FORMAT } from 'utils/formatDate';

export const COLUMNS: ColDef<any>[] = [
  {
    field: 'type',
    headerName: 'Exhibit Title',
    flex: 1,
  },
  {
    field: 'name',
    headerName: 'Resolution name',
    flex: 1,
  },
  {
    field: 'date',
    headerName: 'Date created',
    width: 200,
    sort: 'desc',
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    valueFormatter: (params) => formatDate(params.value, READABLE_DATETIME_FORMAT),
  },
];

export const ExhibitHistoryTable = () => {
  const {
    historyExhibits,
    historyLoading,
    historyCopy,
    historyDelete,
    historyDownload,
  } = useExhibitExporterContext();

  const rows = useMemo(() => historyExhibits.map(toHistoryRow), [historyExhibits]);

  return (
    <ExhibitHistoryGrid
      loading={historyLoading}
      rows={rows}
      columns={COLUMNS}
      onCopy={historyCopy}
      onDownload={historyDownload}
      onDelete={historyDelete}
    />
  );
};

export const toHistoryRow = (e: ExhibitHistory): HistoryGridRow => ({
  id: e.id,
  type: e.exhibitNumber,
  name: e.actionName.actionName,
  date: e.createdDate,
});
